import React from 'react';
import Loader from 'react-loader-spinner'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"

export function Spinner(props) {
    return (
      <Loader style={{marginTop:"15%"}}
         type="Rings"
         color="#00BFFF"
         height={100}
         width={100}/>
    );
}

export function SpinnerCustom(props) {
  const marginTop = props.marginTop ? props.marginTop : 0
  return (
    <Loader style={{marginTop:marginTop}}
       type="Bars"
       color="#000000"
       height={props.height}
       width={props.height}/>
  )
}

export function SpinnerInsidePage(props) {
    const marginTop = "15%"
    return (
      <Loader style={{marginTop:marginTop}}
         type="Bars"
         color="#000000"
         height={props.height}
         width={props.height}/>
    );
}

export function SpinnerOrder(props) {
  return (
    <Loader style={{padding:"30px"}}
       type="Bars"
       color="#000000"
       height={40}
       width={40}/>
  );
}